<template>
  <div class="btbottom">
    <div class="btpc">
      <div class="item">
        <span>联系顾问，咨询详情</span>
        <!-- <button @click="toNext(1)">详情咨询</button> -->
        <a :href="urlForm" target="_blank">
          <button>详情咨询</button>
        </a>
      </div>
      <div class="item">
        <span>限时优惠，点击抢票</span>
        <slot v-if="global.area_id && global.config[global.area_id]">
          <!-- <button @click="toNext(2)" v-if="global.year.includes(thisYear)">领取折扣</button> -->
          <router-link :to="formatHref('/order', {sid: global.area_id})" v-if="global.year.includes(thisYear)">
            <button>领取折扣</button>
          </router-link>
          <button v-else>已售罄</button>
        </slot>
        <button v-else>敬请期待</button>
      </div>
    </div>
    <div class="btmob">
      <!-- <div v-if="global.area_id=='2762'" class="item" @click="toNext(1)">报名咨询</div> -->
      <!-- <div v-else class="item" @click="toNext(1)">内容咨询</div> -->
      <div class="item">
        <a :href="urlForm" target="_blank">{{global.area_id=='2762' ? '报名咨询' : '内容咨询'}}</a>
      </div>
      <slot v-if="global.area_id && global.config[global.area_id]">
        <!-- <div class="item" @click="toNext(2)" v-if="global.year.includes(thisYear)">立即报名</div> -->
        <div class="item" v-if="global.year.includes(thisYear)">
          <router-link :to="formatHref('/order', {sid: global.area_id})">立即报名</router-link>
        </div>
        <div class="item" v-else>已售罄</div>
      </slot>
      <div class="item" v-else>敬请期待</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable eol-last */
import { mixinSession } from '../mixin'

export default {
  name: 'Bottom',
  mixins: [mixinSession],
  data () {
    return {
      // area_id: '',
      thisYear: new Date().getFullYear()
    }
  },
  computed: {
    urlForm () {
      let area_id = this.global.area_id
      return this.global.config[area_id].form_url || (this.global.url['form_url'] + this.global.config[area_id].form_id)
    }
  },
  // created () {
  //   this.area_id = this.global.area_id.toString()
  // },
  methods: {
    toNext: function (n) {
      let hash = ''
      hash = this.global.hashParam['qd']
      // console.log("hash ",hash)
      let area_id = this.global.area_id
      let url = ''
      let url_form = ''
      if (n.toString() === '1' && this.global.config[area_id].form_id > 0) {
        url_form = this.global.config[area_id].form_url || (this.global.url['form_url'] + this.global.config[area_id].form_id)
        if (hash) {
          url = url_form + '&qd=' + hash
        } else {
          url = url_form
        }
        window.open(url, '_blank')
      }
      if (n.toString() === '2') {
        this.$router.push(this.formatHref('/order', {sid: area_id}))
      }
    }
  }
}
</script>

<style>
.btbottom .btpc{
 width: 100%;
 height: 68px;
 padding: 14px 0;
 background: rgba(0,0,0,0.4);
 display: inline-flex;
 flex-wrap: nowrap;
 align-items: center;
 position: fixed;
 bottom: 0;
 left: 0;
 z-index: 100;
}
.btbottom .item{
 width: 50%;
 line-height: 40px;
 font-size: 18px;
 font-family: Source Han Sans CN Regular;
 font-weight: 500;
 color: #ffffff;
}
.btbottom .btpc .item:nth-of-type(1){
 text-align: right;
 padding-right: 35px;
}
.btbottom .btpc .item:nth-of-type(2){
 text-align: left;
 padding-left: 35px;
}
.btbottom .item button{
 width: 150px;
 margin-left: 20px;
 background: var(--deep-color);
 border-radius: 20px;
 border: none;
 color: #ffffff !important;
}
.btbottom .item button:hover{
 /* box-shadow: 3px 3px 3px #9ec4f6; */
 background: #0588CF;
 cursor: url("../../static/images/mouse1.png"), auto !important;
}

.btbottom .btmob{
 width: 100%;
 display: none;
 flex-wrap: nowrap;
 position: fixed;
 bottom: 0;
 left: 0;
 z-index: 100;
}
.btbottom .btmob .item{
 line-height: 50px;
 text-align: center;
 font-size: 16px;
 font-family: PingFang SC;
 font-weight: 500;
}
.btbottom .btmob .item a{
  display: inline-block;
  width: 100%;
  height: auto;
  line-height: 1;
  text-decoration: none;
}
.btbottom .btmob .item:nth-of-type(1){
 background: #F6F9FF;
 border: 1px solid #0d6db5;
 color: #0d6db5;
}
.btbottom .btmob .item:nth-of-type(2){
 background: #1282fb;
 border: 1px solid #0d6db5;
 color: #ffffff;
}
.btbottom .btmob .item:nth-of-type(2) a{
  color: #ffffff;
}
@media (max-width:800px) {
.btbottom .btpc{
 display: none!important;
}
.btbottom .btmob{
 display: inline-flex!important;
}
}
</style>


// WEBPACK FOOTER //
// src/componentsNew/Bottom.vue